var _rect, _path, _rect2, _path2, _rect3, _line, _rect4, _line2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArtAroundTheHome = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 22,
    width: 8,
    height: 16,
    rx: 1,
    stroke: "#D28A60",
    strokeWidth: 2,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 8,50 L 50,14 L 92,50",
    stroke: "#D28A60",
    strokeWidth: 2.5,
    fill: "none",
    strokeLinejoin: "round",
    strokeLinecap: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 50,
    width: 68,
    height: 40,
    rx: 2,
    stroke: "#D28A60",
    strokeWidth: 2.5,
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 40,90 L 40,70 Q 40,63 50,63 Q 60,63 60,70 L 60,90",
    stroke: "#D28A60",
    strokeWidth: 2,
    fill: "none",
    strokeLinejoin: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 60,
    width: 12,
    height: 10,
    rx: 1,
    stroke: "#D28A60",
    strokeWidth: 2,
    fill: "none"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 28,
    y1: 60,
    x2: 28,
    y2: 70,
    stroke: "#D28A60",
    strokeWidth: 1.2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 60,
    width: 12,
    height: 10,
    rx: 1,
    stroke: "#D28A60",
    strokeWidth: 2,
    fill: "none"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 72,
    y1: 60,
    x2: 72,
    y2: 70,
    stroke: "#D28A60",
    strokeWidth: 1.2
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArtAroundTheHome);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/art-around-the-home.aaaa59392c11a8deefff2defbd2c9cd6.svg";